import logo from './logo.svg';
import './App.css';
import { Route, Routes } from 'react-router-dom';
import CustomerProfilePage from './pages/CustomerProfilePage';
import CustomerEdit from './components/customerEdit/CustomerEdit';
import CustomerHistory from './components/customerHistory/CustomerHistory';
import CustomerPhoto from './components/customerPhoto/CustomerPhoto';
import HomePage from './pages/homePage/HomePage';
import LoginPage from './pages/loginPage/LoginPage';
import Register from './components/login/Register';
import BookingBoothComponent from './components/bookingBooth/BookingBoothComponent';
import ChooseSeviceComponent from './components/bookingBooth/chooseService/ChooseServiceComponent'
import PaymentStaff from './components/paymentStaff/PaymentStaff';
import HistoryDetail from './components/customerHistory/HistoryDetail';
import BranchListPage from './pages/branchPage/BranchListPage';
import BoothListPage from './pages/branchPage/BoothListPage';
import BoothDetailPage from './pages/branchPage/BoothDetailPage';
import Header from './components/headeradnfooter/Header';
import Footer from './components/headeradnfooter/Footer';
import PaymentSuccessfull from './components/paymentStaff/PaymentSuccessfull';
import BranchDetail from './components/branch/BranchDetail';
function App() {
  return (
    <>
    <Header/>
   <Routes>
   
    <Route path='/login' element={<LoginPage/>}></Route>
    <Route path='/' element={<HomePage/>}></Route>
    <Route path='/branches_list' element={<BranchListPage/>}></Route>
    <Route path='/branchdetail/:branchID' element={<BranchDetail/>}></Route>
    <Route path='/booths_list' element={<BoothListPage/>}></Route>
    <Route path='/boothdetail/:boothID' element={<BoothDetailPage/>}></Route>
    <Route path='/register' element={<Register/>}></Route>
    <Route path='/booking' element={<BookingBoothComponent/>}></Route>
    <Route path='/chooseservice' element={<ChooseSeviceComponent/>}></Route>
    <Route path='/payment' element={<PaymentStaff/>}></Route>
    <Route path='/paymentinform' element={<PaymentSuccessfull/>}></Route>
    <Route path='/profile' element={<CustomerProfilePage/>}></Route>
    <Route path='/editprofile' element={<CustomerEdit/>}></Route>
    <Route path='/history' element={<CustomerHistory/>}></Route>
    <Route path='/orderdetail/:id' element={<HistoryDetail/>}></Route>
    <Route path='/photo' element={<CustomerPhoto/>}></Route>
   </Routes>
   <Footer/>
   </>
  );
}

export default App;
